import { render, staticRenderFns } from "./materialDetailDialog.vue?vue&type=template&id=378bbb1e&scoped=true&"
import script from "./materialDetailDialog.vue?vue&type=script&lang=js&"
export * from "./materialDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./materialDetailDialog.vue?vue&type=style&index=0&id=378bbb1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378bbb1e",
  null
  
)

export default component.exports